<template>
  <NavBar />
  <RouterView />
  <FooterSection />
  <CookieConsent />
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue';
import NavBar from '@/components/NavBar.vue';
import FooterSection from '@/components/FooterSection.vue';
import CookieConsent from '@/components/CookieConsent.vue';

// Shared head contract: every SSG route renders Spanish explicitly.
// Per-page title/description stay in each view's own useHead call.
useHead({
  htmlAttrs: { lang: 'es-AR' },
});
</script>


